'use strict';

var App = require('app');
var AppState = require('app_state');
var AbstractFormView = require('components/common/views/abstract_form_view');
var Consts = require('consts');
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var ModbusModel = require('models/modbus').Modbus;
var Notification = require('utils/notification');
var RemoteState = require('models/rule').RemoteValueState;
var RemoteValueTransfer = require('models/rule').RemoteValueTransfer;
var RemoteValueView = require('components/devices/remote_values/views/remote_value_view');

var DataInputView = AbstractFormView.extend({
    template: require('components/devices/templates/common/write_value'),

    ui: {
        slider: '#js-slider',
        value: '#js-value-input',
        relativeValue: '#js-relative-value-input',

        btnPlus: '#js-plus',
        btnMinus: '#js-minus',

        selectDevice: '#js-device-select',
        selectedValue: '#js-value-select',
        selectedMeter: '#js-meter-select',
        isDryRun: '#is-dry-run',

        toggleMode: '.js-toggleMode',
        edtLongValue: '#js-value-input-long',

        notEditable: '.js-deny',
    },

    events: {
        'click @ui.btnPlus': 'increaseValue',
        'click @ui.btnMinus': 'decreaseValue',
        'click @ui.toggleMode': 'toggleMode',
        'input @ui.relativeValue': 'inputRelativeVal',
        'keyup #js-value-input-long': 'changeLongValue',
        'change #js-value-input-long': 'changeLongValue',
        'mousedown @ui.notEditable': 'cancelEvent',
        'keydown @ui.notEditable': 'cancelEvent',

        'changed.bs.select @ui.selectedMeter': 'changeValue',
        'change #is-dry-run': 'toggleDryRun',

        'change @ui.slider': function (e) {
            e.preventDefault();
            this.updateValue(true);
        },
        'change @ui.value': function (e) {
            e.preventDefault();
            this.updateValue(false);
        },

        'blur @ui.value': function (e) {
            e.preventDefault();
            this.updateValue(false);
        },
    },

    childEvents: {
        'remote:value:validity': function (_remoteValueView) {
            this.triggerMethod('check:validity');
        },
    },

    regions: {
        remoteValues: '#remote-value-region',
    },

    initialize: function (options) {
        this.model = options.model;
        this.device = options.device;
        this.rvt = options.rvt;
        this.disable = options.disable;
        this.mode = 'absolute';

        if (options.device != undefined && options.device.attributes != undefined) {
            this.allowWeatherConfiguration =
                options.canAccessWeatherData &&
                Consts.ControllerTypes[options.device.get('type')] != undefined &&
                this.model.get('type') === 'MBR' &&
                this.model.isOutdoorSensorDataPoint();

            var categoryID = this.device.get('category');
            if (!categoryID.startsWith('55xx56xx')) {
                categoryID += '/' + this.device.get('type');
            }

            this.initializeRemoteAndFallbackValues(
                this.options.fallbackResponse,
                this.options.registers,
                this.options.coils,
                this.options.selected
            );
        } else {
            // no device specified ..
            // .. disable weather data access
            this.allowWeatherConfiguration = false;
            // .. disable remote value transfer configuration
            this.targetFallbackDisabled = true;
        }

        // determine min-max value range
        this.min = this.model.get('min');
        this.max = this.model.get('max');
        if (this.min == this.max && this.min == 0) {
            this.min = 0;
            this.max = 0xffff;
        }

        this.raw = options.initValue;
        this.sliderInitialized = false;
        $('#js-modal-dialog').one('hide.bs.modal', this.options.closeCallback);
        this.longValue = (
            Misc.getValueDisplayInfos(options.initValue, this.model.get('type'), this.model.get('format')) || {}
        ).value;
        this.stepSize = 1;
    },

    initializeRemoteAndFallbackValues: function (fallbackResponse, registers, coils, selected) {
        selected = selected || [];

        var targetFallbackEnabled = fallbackResponse.success && fallbackResponse.hasAccess;
        var config = fallbackResponse.config;
        var disablingReason = fallbackResponse.disablingReason;

        if (this.model.get('transfer_mode') === Consts.TransferMode.None) {
            // create a default configuration for the view
            this.showRemoteValues = false;
            return;
        }

        if (targetFallbackEnabled) {
            // Skip the first three registers, since they describe the general configuration:
            // - MBR_20000: timeout in Minutes
            // - MBR_20001: total device count with a fallback configuration
            // - MBR_20002: maximum allowed devices with a fallback configuration
            // The following registers describe the configured fallback values (if any)
            var hasConfiguredFallbackvalues = _.some(config.registers.slice(3), function (reg) {
                return reg.value != 0;
            });

            // device has no fallback values? -> check if the gateway allows for an additional device with fallback values
            if (!hasConfiguredFallbackvalues) {
                // (max allowed devices with fallback values) - (current devices with fallback values)
                if (config.registers[2].value - config.registers[1].value < 1) {
                    disablingReason =
                        i18n.TR(
                            'Die maximale Anzahl an unterstützten Geräten mit Rückfallwerten wurde erreicht. Daher können keine weiteren Rückfallwerte konfiguriert werden.'
                        ) +
                        ' (' +
                        i18n.TR('Das Gateway unterstützt bis zu') +
                        ' ' +
                        config.registers[2].value +
                        ' ' +
                        i18n.TR('Geräte') +
                        ').';
                    targetFallbackEnabled = false;
                    config = undefined;
                }
            }
        }

        var values = undefined;
        if (registers && coils && selected) {
            registers.models = _.union(registers.models, coils.models, selected.models);
            values = registers.filter(function (reg) {
                return !reg.attributes.is_readonly;
            });
        }

        this.remoteState = new RemoteState({
            model: this.model,
            rvt: this.rvt,
            device: this.device,
            formats: values,
            fallbackValues: config,
            targetFallbackDisabled: !targetFallbackEnabled,
            disablingReason: disablingReason,
        });

        // have a remote value? -> initialize remoteState
        if (this.remoteState.isValid()) {
            // we are loading an existing remote value - do not display the accordion
            this.singleRegionID = 'remote-value-region';
            this.mode = this.remoteState.getMode();
        }

        this.showRemoteValues = true;
    },

    serializeData: function () {
        var data = AbstractFormView.prototype.serializeData.apply(this, arguments);

        data.refreshRate = this.refreshRate;

        data.model = this.model.toJSON();
        data.min = this.min;
        data.max = this.max;
        data.raw = this.raw;
        data.longValue = this.longValue;

        data.mode = this.mode;

        data.disable = this.disable;
        data.animation = this.animation;

        data.showExtendedInfos = AppState.user.get('is_expert');

        data.enableRelativeMode = true;
        data.enableExternalValues = !this.targetFallbackDisabled;
        data.allowWeatherConfiguration = this.allowWeatherConfiguration;
        data.isLongRegister = this.isLongRegister();

        if (data.isLongRegister) {
            var scripts = this.options.writeInfo.scripts;
            if (scripts.length >= 1) {
                var colWidth = Math.max(Math.round(12 / scripts.length), 3);
                data.registers = _.map(scripts, function (script, idx) {
                    return { raw: '0', col: colWidth, index: idx };
                });
            }
        }

        data.valueName = this.options.model.attributes.type + '_' + this.options.model.attributes.nr;
        data.writeModes = [
            {
                id: 'js-absolute',
                title: data.model.type === 'MBR' ? i18n.TR('Absolutwert') : i18n.TR('Coil setzen'),
                active: this.mode === 'absolute',
                template: 'WRITE_VALUE_ABSOLUTE',
            },
        ];
        // add relative mode
        if (data.model.type === 'MBR') {
            data.writeModes.push({
                id: 'js-relative',
                title: i18n.TR('Relative Änderung'),
                active: this.mode === 'relative',
                template: 'WRITE_VALUE_RELATIVE',
            });
        }

        // add external value mode
        if (data.enableExternalValues) {
            data.writeModes.push({
                id: 'js-remote',
                title: i18n.TR('Fremdwert beziehen'),
                active: this.mode === 'remote',
                region: this.regions['remoteValues'].substr(1),
            });
        }

        // add weather value mode
        if (data.allowWeatherConfiguration) {
            data.writeModes.push({
                id: 'js-weather',
                title: i18n.TR('Wetterdaten'),
                active: this.mode === 'weather',
                template: 'WRITE_VALUE_WEATHER',
            });
        }
        data.singleRegionID = this.singleRegionID;
        return data;
    },

    onRender: function () {
        Misc.initSelectPicker();
        Misc.initDevicePicker();
        this.initializeTypeListener();
        // do not call during first render
        if (this.doRefreshSlider) {
            this.refreshSlider();
        }
    },

    onAttach: function () {
        this.initializeTypeListener();
        $('.selectpicker').selectpicker();
        if (this.isLongRegister()) {
            this.changeLongValue();
        }
    },

    showRemoteValueView: function () {
        this.showChildView(
            'remoteValues',
            new RemoteValueView({
                remoteState: this.remoteState,
                rvt: this.rvt,
                targetValue: this.model,
                values: this.values,
                device: this.device,
                controller: this.options.controller,
            })
        );
        Misc.initSelectPicker();
        Misc.initDevicePicker();
    },

    onShow: function () {
        var self = this;
        this.doRefreshSlider = true;
        if (this.showRemoteValues) {
            this.showRemoteValueView();
        }

        // slider is initialized indirectly, see:
        // https://github.com/seiyria/bootstrap-slider/issues/396
        //check if modal-dialog is already shown - if not, wait until it is shown
        if (($('#js-modal-dialog').data('bs.modal') || {}).isShown) {
            self.refreshSlider();
            self.sliderInitialized = true;
        } else {
            $('#js-modal-dialog').one('shown.bs.modal', function () {
                self.refreshSlider();
                self.sliderInitialized = true;
            });
        }
    },

    onBeforeDestroy: function () {
        // destroy slider
        this.ui.slider.slider('destroy');
    },

    toggleMode: function (e) {
        var newMode = e.target.id.split('-')[1];

        // prevent user from selecting remote mode before it's ready
        if (newMode === 'loading') {
            e.stopPropagation();
            return;
        }
        this.mode = newMode;

        // switching to remote mode the first time? -> load data
        if (this.mode === 'remote' && this.rvt === undefined) {
            Decorator.disableElement('.modal-dialog');

            this.model.set('transfer_mode', Consts.TransferMode.Value);

            var deviceID = this.device.get('id');
            var categoryID = this.device.get('category');
            if (!categoryID.startsWith('55xx56xx')) {
                categoryID += '/' + this.device.get('type');
            }

            var remoteValueRequest = App.request(
                'device:remote_value_transfer',
                this.model.getAddress(),
                deviceID,
                this.model
            );
            var values = this.options.controller.requestValuesForDevices({}, categoryID, [deviceID]);

            var self = this;
            $.when(remoteValueRequest, values[0], values[1], values[4]).done(
                function (remoteValueResponse, registers, coils, selected) {
                    Decorator.enableElement('.modal-dialog');

                    if (remoteValueResponse.success === false) {
                        Notification.show(type, header, message);
                        return;
                    }

                    self.rvt = remoteValueResponse.rvt;
                    self.model.set('transfer_mode', Consts.TransferMode.Value);

                    self.initializeRemoteAndFallbackValues(self.options.fallbackResponse, registers, coils, selected);
                    self.showRemoteValueView();
                    self.triggerMethod('check:validity');
                }
            );
        } else {
            this.triggerMethod('check:validity');
        }
    },

    cancelEvent: function (e) {
        e.preventDefault();
        return false;
    },

    isLongRegister: function () {
        return this.options.writeInfo && this.options.writeInfo.scripts && this.options.writeInfo.scripts.length;
    },

    getLongRegisterValue: function () {
        var longValue = parseFloat(this.ui.edtLongValue.val());
        return Misc.getRawValue(longValue, this.model.get('type'), this.model.get('format'));
    },

    getLongRegisterValues: function () {
        var baseNr = 0xffffffff >>> 0;
        // get raw value
        var rawValue = this.getLongRegisterValue();
        var prefix = this.options.writeInfo.prefix || {};
        var sigMap = { 'SIG1#': 0x100, 'SIG2#': 0x10000, 'SIG4#': 0x100000000 };
        _.each(sigMap, function (v, k) {
            if (prefix[k]) {
                if (rawValue < 0) {
                    rawValue = v + rawValue;
                }
                rawValue = (baseNr & rawValue) >>> 0;
            }
        });

        var values = _.map(this.options.writeInfo.scripts, function (script, idx) {
            var valueScript = script.replaceAll('~VALUE', '' + rawValue);
            try {
                var rawRegValue = (Math.floor(Misc.evalPrefixed(valueScript)) & 0xffff) >>> 0;
                if (prefix['LE#']) {
                    rawRegValue = Misc.le2be(rawRegValue);
                }
                return rawRegValue;
            } catch (e) {}
            return 0;
        });
        return values;
    },

    changeLongValue: function () {
        _.each(this.getLongRegisterValues(), function (rawRegValue, idx) {
            $('#js-value-reg-' + idx).val(rawRegValue);
        });
    },

    toggleDryRun: function () {
        this.isDryRun = !this.isDryRun;
        // show correct warning message
        if (this.isDryRun === true) {
            $('#js-preview-info').removeClass('hidden');
            $('#js-activation-warning').addClass('hidden');
        } else {
            $('#js-preview-info').addClass('hidden');
            $('#js-activation-warning').removeClass('hidden');
        }
    },

    changeValue: function () {
        this.selectedMeterID = parseInt($(this.ui.selectedMeter).val());
        this.triggerMethod('check:validity');
    },

    initializeTypeListener: function () {
        $('.panel-heading a').on('click', function (e) {
            e.preventDefault();

            // try to open opened element? -> do nothing
            var target = $($(e.currentTarget).attr('href'));
            if (target.hasClass('in')) {
                e.stopPropagation();
            }
        });
    },

    inputRelativeVal: function () {
        var input = parseInt(this.ui.relativeValue.val());
        $('#js-input-sign').text(input >= 0 ? '+' : '-');
        if (input < -100) {
            this.ui.relativeValue.val(-100);
        }
    },

    updateValue: function (fromSlider) {
        if (fromSlider) {
            // read from slider -> apply to input field
            this.ui.value.val(this.ui.slider.slider('getValue'));
        } else {
            // read from input field -> apply to slider
            if (this.sliderInitialized) {
                this.ui.slider.slider('setValue', this.ui.value.val());
            }
        }

        // always: ensure that input field is in min/max range
        var input = parseInt(this.ui.value.val()) || 0;
        input = Misc.clamp(input, this.min, this.max);

        this.ui.value.val(input);
    },

    increaseValue: function () {
        switch (this.mode) {
            case 'absolute':
                var current = this.ui.slider.slider('getValue');
                if (current < this.max) {
                    this.ui.slider.slider('setValue', current + 1);
                    this.updateValue(true);
                }
                break;
            case 'relative':
                var current = parseInt(this.ui.relativeValue.val());
                this.ui.relativeValue.val(((current / 5) >> 0) * 5 + 5);
                this.inputRelativeVal();
                break;
        }
    },

    decreaseValue: function () {
        switch (this.mode) {
            case 'absolute':
                var current = this.ui.slider.slider('getValue');
                if (current > this.min) {
                    this.ui.slider.slider('setValue', current - 1);
                    this.updateValue(true);
                }
                break;
            case 'relative':
                var current = parseInt(this.ui.relativeValue.val());
                this.ui.relativeValue.val(((current / 5) >> 0) * 5 - 5);
                this.inputRelativeVal();
                break;
        }
    },

    refreshSlider: function () {
        var self = this;
        this.ui.slider.slider({
            tooltip: 'always',
            min: this.min,
            max: this.max,
            value: this.raw,
            formatter: function (value) {
                return Handlebars.helpers.DISPLAY_VALUE_PLAIN(self.model.attributes, value, {});
            },
        });
    },
});

var DataEditDialogView = Marionette.LayoutView.extend({
    template: require('components/devices/templates/common/data_edit'),

    regions: {
        dataInputRegion: '#dataInput',
    },

    ui: {
        btnWrite: '#js-save',
        btnStop: '#js-stop',
    },

    events: {
        'click @ui.btnWrite': 'validateForm',
        'click @ui.btnStop': 'stopProcedure',
    },

    initialize: function (options) {
        this.options = options;
        this.options.initValue = options.model.getRawValue ? options.model.getRawValue() : options.model.get('min');
        this.controller = options.controller;
        this.model.set('remoteValue', options.rvt && options.rvt.valid());
    },

    serializeData: function () {
        var data = Marionette.LayoutView.prototype.serializeData.apply(this, arguments);

        if (this.model.get('remoteValue')) {
            data.title = i18n.TR('Fremdwert beziehen');
            data.action = i18n.TR('Speichern');
        } else {
            data.title = i18n.TR('Wert schreiben');
            data.action = i18n.TR('Schreiben');
        }
        return data;
    },

    onChildviewCheckValidity: function (inputView) {
        var isRemoteValue = inputView.mode == 'remote';
        if (isRemoteValue) {
            var remoteValueIsInvalid = !inputView.getChildView('remoteValues').isValid();
        }

        // invalid- or incomplete values -> disable save button
        Misc.setDisabled(this.ui.btnWrite, isRemoteValue && remoteValueIsInvalid);
    },

    validateForm: function (e) {
        e.preventDefault();
        var input = this.dataInputView;

        if (!input.allFieldsValid()) {
            return;
        }
        switch (input.mode) {
            case 'remote':
                // new rule? -> create a new rule-object
                var remoteValuesView = input.getChildView('remoteValues');
                var tv = remoteValuesView.getTargetFallbackValues(this.options.fallbackResponse);

                Decorator.disableElement('.modal-dialog');

                var targetRequest = this.controller.writeTargetOfflineValues(tv, input.device);
                var rvtRequest = this.controller.saveRemoteValueTransfer(remoteValuesView.getTransfer());

                Promise.allSettled([targetRequest, rvtRequest]).then(function (responseList) {
                    var targetRsp = responseList[0];
                    var rvtRsp = responseList[1];
                    if (targetRsp.status === 'fulfilled' && rvtRsp.status === 'fulfilled') {
                        App.hideModal();
                        Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Einstellungen wurden gespeichert.'));
                        // update icons on page to refelct the new state
                        Backbone.history.loadUrl(Backbone.history.fragment);
                    } else {
                        var errorMessage = i18n.TR('Einstellungen konnten nicht gespeichert werden.');
                        if (targetRsp.status === 'fulfilled' && rvtRsp.status === 'rejected') {
                            errorMessage = i18n.TR('Fremdwertbezug konnte nicht gespeichert werden.');
                        }
                        if (targetRsp.status === 'rejected' && rvtRsp.status === 'fulfilled') {
                            errorMessage = i18n.TR('Rückfallwerte konnten nicht geschrieben werden.');
                        }

                        Decorator.enableElement('.modal-dialog');
                        Notification.show('error', i18n.TR('Fehler'), errorMessage);
                    }
                });
                break;

            case 'weather':
                // new rule? -> create a new rule-object
                if (input.rvt == undefined || input.rvt.valid()) {
                    input.rvt = new RemoteValueTransfer();
                }

                input.rvt.set('device_id', input.device.get('id'));
                input.rvt.set('id', input.model.getAddress());
                // refresh weather data every 15 Minutes
                input.rvt.set('refresh_rate', Consts.MinimumWeatherDataTransferFreq);

                input.rvt.setRuleSimpleTransfer('WD', []);

                if (this.options.saveCallback) {
                    this.options.saveCallback();
                }
                $.when(this.controller.saveRemoteValueTransfer(input.rvt)).done(function (response) {
                    if (response === 'rvt_failed') {
                        Notification.show('error', i18n.TR('Fehler'), errorMessage);
                    } else {
                        App.hideModal();
                        Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Einstellungen wurden gespeichert.'));
                        // update icons on page to refelct the new state
                        Backbone.history.loadUrl(Backbone.history.fragment);
                    }
                });
                break;

            case 'absolute':
            case 'relative':
                var form = Backbone.Syphon.serialize(input);
                Decorator.disableElement('.modal-dialog');
                var mbValue = new ModbusModel({
                    id: input.model.get('nr'),
                    device: input.model.get('device'),
                    type: input.model.get('type'),
                    value:
                        input.mode == 'relative'
                            ? parseInt(form.relativeValue)
                            : parseInt(form.value || form.coil_select),

                    register_values:
                        input.isLongRegister() && input.mode != 'relative' ? input.getLongRegisterValues() : [],
                    raw_value:
                        input.isLongRegister() && input.mode != 'relative' ? input.getLongRegisterValue() : undefined,

                    length: input.model.get('length'),
                    is_relative: input.mode == 'relative',
                    modelID: input.model.id,
                });

                if (this.options && this.options.saveCallback) {
                    this.options.saveCallback();
                }
                this.controller.saveValue(mbValue, this.getOption('callback'));
                break;
        }
    },

    stopProcedure: function () {
        this.stopRemoteValueTranfer();
    },

    stopRemoteValueTranfer: function () {
        if (this.dataInputView.rvt.valid()) {
            this.dataInputView.rvt.destroy({
                success: function () {
                    App.hideModal();
                    Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Fremdwertbezug beendet.'));
                    Backbone.history.loadUrl(Backbone.history.fragment);
                },
                error: function (_errors) {
                    Decorator.enableElement('.modal-dialog');
                    App.hideModal();
                    Notification.show('error', i18n.TR('Fehler'), i18n.TR('Befehl konnte nicht ausgeführt werden.'));
                },
            });
        }
    },

    onShow: function () {
        this.dataInputView = new DataInputView(this.options);
        this.showChildView('dataInputRegion', this.dataInputView);
    },
});

module.exports = {
    Input: DataInputView,
    Dialog: DataEditDialogView,
};
